function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".add_branch_active_svg__cls-1{fill:none;stroke:#6cff00}"));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "add_branch_active_svg__Group_21649",
  transform: "translate(.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "add_branch_active_svg__Ellipse_684",
  className: "add_branch_active_svg__cls-1",
  transform: "translate(-.001)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 7.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "add_branch_active_svg__Line_521",
  d: "M0 0v8.501",
  className: "add_branch_active_svg__cls-1",
  transform: "translate(7.909 3.52)"
}), /*#__PURE__*/React.createElement("path", {
  id: "add_branch_active_svg__Line_522",
  d: "M8.501 0H0",
  className: "add_branch_active_svg__cls-1",
  transform: "translate(3.659 7.771)"
}));
function SvgAddBranchActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "add_branch_active_svg__Component_118_171",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' id='Component_118_171' width='16' height='16' viewBox='0 0 16 16'%3e %3cdefs%3e %3cstyle%3e .cls-1%7bfill:none;stroke:%236cff00%7d %3c/style%3e %3c/defs%3e %3cg id='Group_21649' transform='translate(.001)'%3e %3cg id='Ellipse_684' class='cls-1' transform='translate(-.001)'%3e %3ccircle cx='8' cy='8' r='8'/%3e %3ccircle cx='8' cy='8' r='7.5' fill='none'/%3e %3c/g%3e %3cpath id='Line_521' d='M0 0L0 8.501' class='cls-1' transform='translate(7.909 3.52)'/%3e %3cpath id='Line_522' d='M8.501 0L0 0' class='cls-1' transform='translate(3.659 7.771)'/%3e %3c/g%3e %3c/svg%3e";
export { SvgAddBranchActive as ReactComponent };